module.exports = __webpack_public_path__ + "79f833803f2f14af3c2a90732bb90c0f.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/audios/1000_r_70.mp3
// module id = 438
// module chunks = 0